import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { NavigationService } from '@services/nav/nav.service';
import { BusinessFeatureFlagSelectors, BusinessState } from '@state/business';
import { MatterFormDataState } from '@state/matter/form-data';
import { of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

// Delete this file once the feature is completely out.
export const sc20628EnableGenericFormsGuard: CanActivateFn = (route) => {
	const navService = inject(NavigationService);
	const matterId = route.paramMap.get('matterId');
	const formDataState = inject(MatterFormDataState);
	const store = inject(Store);
	return store.select(BusinessState.getLoaded).pipe(
		filter((loaded) => loaded),
		switchMap(() =>
			store.selectSnapshot(BusinessFeatureFlagSelectors.isGenericFormsEnabled)
				? formDataState.repo
						.Count({
							businessId: store.selectSnapshot(BusinessState.businessId),
							matterId,
						})
						.then((count) => count === 0) // If there are any overrides we show the legacy
						.catch(() => false) // Fallback to false if there's an error
				: of(false),
		),
		map((isGenericFormsEnabled) => {
			if (route.routeConfig.path === 'forms' && isGenericFormsEnabled) {
				navService.goToMatter_Documents_Generic_Forms(matterId);
				return false;
			} else if (route.routeConfig.path !== 'forms' && !isGenericFormsEnabled) {
				navService.goToMatter_Documents_Forms(matterId);
				return false;
			}
			return true;
		}),
	);
};
